import React, {  useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import {
    SidebarContainer,
    SidebarWrapper,
    InfoWrapper,
    InfoMap,
    ItemMap,
    Icon,
    CloseIcon
} from './sidebarElements'
import {  mapStateToProps } from '../funtComponents/models/buscar';
import { connect, useDispatch } from 'react-redux';
import * as redux from '../../redux/constanst/index';

import AccountBoxIcon from '@mui/icons-material/AccountBox';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ThreePIcon from '@mui/icons-material/ThreeP';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const Sidebar = (props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleSelected = (item) => {
        dispatch({ type: redux.IDBUSCAR_STATE_CHANGE, idBuscar: item })
        dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: [] })

        dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: [] })
        dispatch({ type: redux.PESELECT_STATE_CHANGE, preselect: false })
        if (window.location.pathname === "/mimegacall/" || window.location.pathname === "/mimegacall" ) {
            props.token.level === "admin" ? navigate('/AdminEdit'):   navigate('/Tablero');
        }
        
        props.token.level === "admin" ? navigate('/AdminEdit'):   navigate('/Tablero');
    }
    
useEffect(() => {
    if(props.token !== null){
        
        if(props.token.cuentas_asociadas.length === 0){
            handleSelected(props.token)
        }
    }


// eslint-disable-next-line react-hooks/exhaustive-deps
}, [props.token])

    const handleClose = () => {
        dispatch({ type: redux.PESELECT_STATE_CHANGE, preselect: false })
    }

    return (
        <SidebarContainer isOpen={props.preselect} >

            { props.idBuscar !== null ?
                <Icon >
                    <CloseIcon onClick={handleClose} />
                </Icon> : null}

            <SidebarWrapper>
                <InfoWrapper>

                    <div style={{
                        display: 'flex', flex: 1, width: '100%', height: '100%',
                        alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
                    }}>
                        <div style={{
                            display: 'flex', width: '100%', height: 'auto',
                            alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
                        }}>
                            {props.idBuscar !== null ?

                                <div style={{
                                    display: 'flex', width: '100%', height: 'auto',
                                    alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
                                }}>
                                    <FactCheckIcon style={{ width: '50%', height: '50%', color: 'ffffff' }} />
                                    <h4 style={{ color: 'white', marginBottom: 5, alignSelf: 'center', }}>Sucursales: {props.token?.cuentas_asociadas.length}</h4>
                                    <h2 style={{ color: 'white', marginBottom: 50 }}>Elige entre tus sucursales</h2>
                                </div>
                                :
                                <div style={{
                                    display: 'flex', width: '100%', height: 'auto',
                                    alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
                                }}>
                                    <AccountBoxIcon style={{ width: '50%', height: '50%', color: 'ffffff' }} />
                                    <h4 style={{ color: 'white', marginBottom: 5, alignSelf: 'center', }}>has ingresado con:</h4>
                                    <h2 style={{ color: 'white', marginBottom: 40 }}>{props?.token?.name}</h2>
                                    <h4 style={{ color: 'lightgrey', fontSize: 14, cursor: 'pointer', marginBottom: 5, alignSelf: 'center' }}
                                    onClick={handleClose}>ingresar con otra cuenta</h4>
                                </div>}

                        </div>
                    </div>

                    <div style={{
                        display: 'flex', flex: 1, width: '100%', height: '100%',
                        alignItems: 'center', justifyContent: 'center', flexDirection: 'column', 
                    }}>
                        {props.idBuscar !== null ?
                            null :
                            <h2>Selecciona una sucursal</h2>}
                        <InfoMap >
                            { 
                                props.token?.cuentas_asociadas.map((item) => (
                                    <ItemMap key={item.name} onClick={() => handleSelected(item)} style={{  color:item, borderColor: props.idBuscar?.name.includes(item.name) ? 8 : null}}>
                                        <div style={{
                                            display: 'flex', alignContent:'center', marginLeft:'auto', marginRight:'auto', wordWrap:'word-break',
                                            alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row'
                                        }}>
                                        <h3>{item.name}</h3>
                                        
                                        
                                        </div>

                                        <div style={{
                                            display: 'flex', width: '100%', marginLeft: 50,
                                            alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row',
                                        }}>
                                            <ThreePIcon style={{ width: 20, height: 20, color: 'ffffff', marginRight: 0 }} />
                                            {item.level}{props.idBuscar?.name.includes(item.name) ? 
                                        <CheckCircleIcon style={{ width: 20, height: 20, color: 'ffffff', marginLeft: 10, }} /> : null }
                                        </div>
                                    </ItemMap>
                                 ))
                          
                        }
                        


                        </InfoMap>

                    </div>

                </InfoWrapper>
            </SidebarWrapper>
        </SidebarContainer>
    )
}


export default connect(mapStateToProps, null)(Sidebar);
